import { render, staticRenderFns } from "./placard_index.vue?vue&type=template&id=f8749382&scoped=true"
import script from "./placard_index.vue?vue&type=script&lang=js"
export * from "./placard_index.vue?vue&type=script&lang=js"
import style0 from "./placard_index.vue?vue&type=style&index=0&id=f8749382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8749382",
  null
  
)

export default component.exports